import { render, staticRenderFns } from "./HistorialAcciones.vue?vue&type=template&id=793afa1e"
import script from "./HistorialAcciones.vue?vue&type=script&lang=js"
export * from "./HistorialAcciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports